import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: "root" })
export class AgentChatViewHandlers {
  hasAssistantThumbsUpHandler = signal(false);

  hasAssistantThumbsDownHandler = signal(false);

  hasAssistantReadAloudHandler = signal(false);

  hasAssistantRegenerateHandler = signal(false);

  hasUserCopyHandler = signal(false);

  hasUserEditHandler = signal(false);
}
